import * as constants from "./constants";

export const setProjectDetailsIsEdit = (data) => {
  return {
    type: constants.PROJECT_DETAILS_IS_EDIT,
    data: data,
  };
};

export const createProject = (data) => {
  return {
    type: constants.CREATE_PROJECT,
    data: data,
  };
};

export const createProjectSuccess = (data) => {
  return {
    type: constants.CREATE_PROJECT_SUCCESS,
    data: data,
  };
};

export const createProjectError = () => {
  return {
    type: constants.CREATE_PROJECT_ERROR,
  };
};

export const fetchProject = (data) => {
  return {
    type: constants.FETCH_PROJECT,
    data: data,
  };
};

export const fetchProjectSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECT_SUCCESS,
    data,
  };
};

export const fetchProjectError = () => {
  return {
    type: constants.FETCH_PROJECT_ERROR,
  };
};

export const updateProject = (data) => {
  return {
    type: constants.UPDATE_PROJECT,
    data: data,
  };
};

export const updateProjectSuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_SUCCESS,
    data: data,
  };
};

export const updateProjectError = () => {
  return {
    type: constants.UPDATE_PROJECT_ERROR,
  };
};

export const fetchProjectDetailsUtils = () => {
  return {
    type: constants.FETCH_PROJECTS_UTIL_DATA,
  };
};

export const fetchProjectDetailsUtilsSuccess = (data) => {
  return {
    type: constants.FETCH_PROJECTS_UTIL_DATA_SUCCESS,
    data,
  };
};

export const fetchAllProjects = (data) => {
  return {
    type: constants.FETCH_ALL_PROJECTS,
    data,
  };
};

export const fetchAllProjectsSuccess = (data) => {
  return {
    type: constants.FETCH_ALL_PROJECTS_SUCCESS,
    data,
  };
};
export const fetchAllProjectsError = (data) => {
  return {
    type: constants.FETCH_ALL_PROJECTS_ERROR,
    data,
  };
};
export const deleteProject = (data) => {
  return {
    type: constants.DELETE_PROJECT,
    data,
  };
};

export const deleteProjectSuccess = (data) => {
  return {
    type: constants.DELETE_PROJECT_SUCCESS,
    data,
  };
};

export const deleteProjectError = (data) => {
  return {
    type: constants.DELETE_PROJECT_ERROR,
    data,
  };
};

export const deleteProjectAttach = (data) => {
  return {
    type: constants.DELETE_PROJECT_ATTACH,
    data,
  };
};

export const deleteProjectAttachSuccess = (data) => {
  return {
    type: constants.DELETE_PROJECT_ATTACH_SUCCESS,
    data,
  };
};

export const deleteProjectAttachError = (data) => {
  return {
    type: constants.DELETE_PROJECT_ATTACH_ERROR,
    data,
  };
};

export const projectDetailCleanupFunc = () => {
  return {
    type: constants.PROJECT_DETAIL_CLEANUP_FUNC,
  };
};

export const setProjectNotificationIsEdit = (data) => {
  return {
    type: constants.PROJECT_NOTIF_IS_EDIT,
    data: data,
  };
};

export const updateProjectNotifications = (data) => {
  return {
    type: constants.UPDATE_PROJECT_NOTIFICATION,
    data: data,
  };
};

export const updateProjectNotificationsSuccess = (data) => {
  return {
    type: constants.UPDATE_PROJECT_NOTIFICATION_SUCCESS,
    data: data,
  };
};

export const updateProjectNotificationsError = () => {
  return {
    type: constants.UPDATE_PROJECT_NOTIFICATION_ERROR,
  };
};
